import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import { toastr } from 'react-redux-toastr';

import api from 'core/api';

async function fetchUnwindingProposalCenter(Page, filters) {
  const query = await api.get(`/unwinding/proposals?${qs.stringify(
    { Page, PageSize: 11, Filters: filters },
    { arrayFormat: 'repeat', allowDots: true },
  )}`).then(({ data }) => {
    toastr.success('Sucesso...', 'Propostas carregadas!');
    return data;
  }).catch(() => {
    toastr.error('Ops...', 'Não foi possível carregar as propostas.');
  });

  return query;
}

function useUnwindingProposalCenter(currentPage, filters) {
  const {
    data,
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useQuery(['unwinding proposal center', currentPage, filters],
    async () => fetchUnwindingProposalCenter(currentPage, filters));

  return {
    filters: {
      Status: data?.filters.status || [],
      ProposalDates: data?.filters.proposalDates || [],
      AdvisorCodes: data?.filters.advisorCodes || [],
      Clients: data?.filters.clients || [],
      Tickers: data?.filters.tickers || [],
      Structures: data?.filters.structures || [],
      OperationType: data?.filters.operationType || [],
    },
    proposals: data?.proposals,
    totalPages: data?.totalPages,
    currentPage: data?.currentPage,
    status: data?.statusCode,
    isLoading,
    isError,
    isSuccess,
    refetchUnwinding: refetch,
  };
}

export default useUnwindingProposalCenter;
